import { Card, Space, Typography } from "antd";

import { ClaimForm } from "../components/ClaimForm";

const { Title } = Typography;

const CreateClaim = () => {
  return (
    <Space
      direction="vertical"
      style={{ margin: 10, width: "-webkit-fill-available" }}
    >
      <Card>
        <Title level={3} style={{ marginBottom: "1em" }}>
          Apply Claim
        </Title>
        <Title
          level={5}
          style={{ color: "#0C377C", textTransform: "uppercase" }}
        >
          Claim Information
        </Title>

        <ClaimForm mode="create" />
      </Card>
    </Space>
  );
};

export default CreateClaim;
